interface ConnectionQualityProps {
  quality: 'excellent' | 'good' | 'poor' | 'disconnected';
}

const qualityConfig = {
  excellent: { bars: 4, color: 'bg-emerald-400', label: 'Mükemmel', textColor: 'text-emerald-400' },
  good: { bars: 3, color: 'bg-yellow-400', label: 'İyi', textColor: 'text-yellow-400' },
  poor: { bars: 1, color: 'bg-red-400', label: 'Zayıf', textColor: 'text-red-400' },
  disconnected: { bars: 0, color: 'bg-white/20', label: 'Bağlantı Yok', textColor: 'text-white/40' },
};

const ConnectionQuality = ({ quality }: ConnectionQualityProps) => {
  const config = qualityConfig[quality];
  const heights = [4, 7, 10, 14];

  return (
    <div className="flex items-center gap-2">
      {/* Signal bars */}
      <div className="flex items-end gap-0.5">
        {heights.map((h, i) => (
          <div
            key={i}
            className={`w-1 rounded-sm transition-colors duration-500 ${
              i < config.bars ? config.color : 'bg-white/15'
            }`}
            style={{ height: `${h}px` }}
          />
        ))}
      </div>
      <span className={`text-xs font-medium ${config.textColor}`}>{config.label}</span>
    </div>
  );
};

export default ConnectionQuality;
